import { fetchGenericSorted, fetchGeneric } from './GenericQ'

import { RCapaResineSchema_Type } from '@batical/types/src'

const DataResine = require('../json/CapaciteResine.json')

export function fetchCapaciteTraitementResineSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(DataResine)
}

export function fetchCapaciteTraitementResine(uuid: string): RCapaResineSchema_Type {
  return fetchGeneric(DataResine, uuid)
}
